module.exports = __webpack_public_path__ + "static/img/demand-widget-4.d45a79f2.png";